// Temporary metadata map - needs to be replaced with meta data from the article query once available

type Metadata = {
  title: string;
  description: string;
};

export type MetadataMap = {
  [key: string]: Metadata;
};

export const metadataMap: MetadataMap = {
  '298751.dda06d': {
    title: 'Die Bewerbungsmappe: So überzeugst Du mit Struktur & Inhalt | XING',
    description:
      'Entdecke wertvolle Tipps zur Erstellung einer optimalen Bewerbungsmappe, die Deine Chancen auf den Traumjob erhöht – inkl. Struktur, Anlagen & häufige Fehler.',
  },
  '298886.812fcf': {
    title:
      'Das Motivationsschreiben: Tipps und Schritt-für-Schritt-Anleitung | XING',
    description:
      'Lerne, wie du ein überzeugendes Motivationsschreiben für Studium, Job oder Stipendium erstellst. Entdecke hilfreiche Tipps und eine Schritt-für-Schritt-Anleitung.',
  },
  '298910.c8e426': {
    title: 'Das perfekte Bewerbungsschreiben: Aufbau & Tipps | XING',
    description:
      'Erfolgreiche Bewerbungen mit dem perfekten Bewerbungsschreiben: Aufbau, Tipps und Fehlervermeidung für den entscheidenden Vorteil im Bewerbungsprozess.',
  },
  '298911.3d13db': {
    title: 'Das Empfehlungsschreiben – Alles, was Du wissen musst | XING',
    description:
      'Erfahre, wie du Empfehlungsschreiben erstellst, die überzeugen. Lerne verschiedene Arten kennen, vermeide häufige Fehler und steigere deine Karrierechancen.',
  },
  '298912.51f19b': {
    title: 'Schlusssatz Bewerbung: So beendest Du Dein Anschreiben überzeugend',
    description:
      'Entdecke, wie du einen überzeugenden Schlusssatz für deine Bewerbung formulierst, mit Beispielen, Tipps und Strategien, um häufige Fehler zu vermeiden.',
  },
  '298993.bfb118': {
    title: 'Jobwechsel in Planung? Unsere Tipps für den reibungslosen Ablauf',
    description:
      'Entdecke effektive Strategien, um einen Jobwechsel zu begründen. Lerne, positive und überzeugende Begründungen zu formulieren und deine berufliche Neuorientierung zu kommunizieren',
  },
  '298959.725864': {
    title: 'Perfektes Deckblatt für Deine Bewerbung: Top Tipps und Beispiele',
    description:
      'Entdecke die Bedeutung des Deckblatts in der Bewerbung, wie du es erfolgreich gestaltest und mit nützlichen Tipps den besten Eindruck hinterlässt.',
  },
  '298969.844888': {
    title: 'Perfekter Einleitungssatz in der Bewerbung: Unsere Experten-Tipps',
    description:
      'Erfolgreiche Bewerbung beginnt mit dem Einleitungssatz: Lerne, wie du deine Motivation und Eignung treffend präsentierst und deine Chancen auf den Traumjob erhöhst.',
  },
  '298976.d85ab7': {
    title: 'Interne Bewerbung: Deine Chance auf eine Beförderung nutzen',
    description:
      'Steigere Deine Erfolgschancen bei internen Bewerbungen! Entdecke Tipps und Strategien für Anschreiben, Lebenslauf und Bewerbungsgespräche. Maximiere Deine Karrierechancen im Unternehmen.',
  },
  '299378.f17b0b': {
    title: 'Wie Du Soft Skills in der Bewerbung erfolgreich einsetzt',
    description:
      'Entdecke die Bedeutung von Soft Skills in der Bewerbung, lerne, welche am meisten gefragt sind und wie Du sie effektiv in Lebenslauf und Vorstellungsgespräch darstellst.',
  },
  '299374.023738': {
    title: 'Online Bewerbung: So überzeugst Du jeden Arbeitgeber',
    description:
      'Entdecke den ultimativen Leitfaden für eine erfolgreiche Online-Bewerbung. Erfahre, was wichtig ist und wie du dich effektiv präsentierst.',
  },
  '299373.ee8ba5': {
    title: 'EDV-Kenntnisse im Lebenslauf: So stichst Du hervor',
    description:
      'Entdecke, wie du EDV-Kenntnisse im Lebenslauf darstellst, um deine Karrierechancen zu verbessern. Lerne, was gute Computerkenntnisse ausmacht und wie du sie erweiterst.',
  },
  '299362.21f60a': {
    title: 'Initiativbewerbung: So überzeugst Du potenzielle Arbeitgeber',
    description:
      'Erfahre, wie du eine überzeugende Initiativbewerbung erstellst und deine Chancen auf den Traumjob erhöhst. Tipps für Anschreiben, Lebenslauf und mehr.',
  },
  '299309.fc4678': {
    title: 'Anlagen in der Bewerbung: Dein Leitfaden zum Erfolg',
    description:
      'Erfahre alles über Anlagen in der Bewerbung: Was gehört dazu, wie erstellst du ein Anlagenverzeichnis und welche Anlagen sind unverzichtbar? Bereite deine Bewerbung optimal vor.',
  },
  '299298.70c4ae': {
    title: 'Wiedereinstieg: Dein Wegweiser zum beruflichen Neustart',
    description:
      'Entdecke, wie du EDV-Kenntnisse im Lebenslauf darstellst, um deine Karrierechancen zu verbessern. Lerne, was gute Computerkenntnisse ausmacht und wie du sie erweiterst.',
  },
  '299297.a35a27': {
    title:
      'Das Vorstellungsgespräch: Vorbereitung ist Dein Schlüssel zum Erfolg',
    description:
      'Erfahre, wie du dich optimal auf ein Vorstellungsgespräch vorbereitest und selbstbewusst auftrittst. Tipps für Fragen, Stresssituationen und einen positiven ersten Eindruck.',
  },
  '300915.60b439': {
    title: 'Das perfekte Bewerbungsfoto – Tipps & Informationen für Dein Foto',
    description:
      'Bewerbungsfoto im Lebenslauf: Vor- & Nachteile, Tipps für ein perfektes Foto und Entscheidungshilfen für die optimale Präsentation in Deiner Bewerbung.',
  },
  '300841.15828e': {
    title: 'Der tabellarische Lebenslauf: Aufbau, Inhalt & hilfreiche Tipps',
    description:
      'Der tabellarischer Lebenslauf: Strukturiert, übersichtlich & präzise. Erfahre hier mehr über Unterschiede, Verwendungszwecke und wichtige Inhalte.',
  },
  '301206.98a37b': {
    title: 'Schüler-Lebenslauf gestalten: Erfolgreiche Vorlagen und Tricks',
    description:
      'Lebenslauf für Schüler: Entdecke hilfreiche Tipps und Anleitungen für den perfekten Lebenslauf, ob für ein Schülerpraktikum oder den ersten Job. Jetzt mehr erfahren!',
  },
  '301186.5d3852': {
    title: 'Lebenslauf auf Englisch: Inhalt, Aufbau & Muster zum download',
    description:
      'Erfahre, welche Unterschiede zum deutschen Lebenslauf bestehen und wie du ihn am besten strukturieren solltest. Erstelle dir mit unserer Vorlage gleich einen eigenen Lebenslauf.',
  },
  '301113.9871ab': {
    title: 'Lebenslauf unterschreiben? Darauf solltest Du genau achten!',
    description:
      'Hier erfährst Du, warum die Unterschrift im Lebenslauf wichtig ist, wie sie die Glaubwürdigkeit erhöht und wie Du sie richtig einfügst - analog oder digital.',
  },
  '301179.6c5d52': {
    title: 'Schlusssatz Bewerbung: So überzeugst Du jeden Arbeitgeber!',
    description:
      'Hier erfährst du, wie du mit einem überzeugenden Schlusssatz in deiner Bewerbung positiv auffallen kannst. Wir haben zahlreiche Beispiele und Tipps für Formulierungen.',
  },
  '301208.374dd4': {
    title: 'Der perfekte Lebenslauf für die Ausbildung: Aufbau, Inhalt & Tipps',
    description:
      'Entdecke hier, wie du einen überzeugenden Lebenslauf für eine Ausbildung erstellst. Erfahre, welche Informationen wichtig sind und nutze eine der vielen Mustervorlagen für deinen Erfolg.',
  },
  '301116.431d9b': {
    title: 'Hobbys im Lebenslauf: Angeben oder einfach weglassen?',
    description:
      'Zeige deine persönlichen Interessen und Fähigkeiten. Finde heraus, mit welchen Hobbys Du am besten in deiner Bewerbung Punkten kannst sind und wie du sie professionell präsentiert.',
  },
  '301342.92a68a': {
    title: 'Sprachkenntnisse im Lebenslauf präsentieren und optimal punkten!',
    description:
      'Optimiere deinen Lebenslauf mit diesen Tipps zur Darstellung von Sprachkenntnissen. Setze auf eindrucksvolle Präsentation und erhöhe deine Karrierechancen!',
  },
  '301303.e8b04f': {
    title: 'Fähigkeiten & Kenntnisse im Lebenslauf - Was darf nicht fehlen?',
    description:
      'Erfahre, wie Du Deine Hard und Soft Skills im Lebenslauf effektiv darstellst, um Deine Bewerbungschancen zu erhöhen. Tipps zur Identifikation, Anpassung und Präsentation relevanter Fähigkeiten findest Du hier!',
  },
  '301091.a3514e': {
    title: 'Aufbau und Inhalt eines perfekten Lebenslaufs | Lebenslauf.com',
    description:
      'Was muss in deinen Lebenslauf rein und was bleibt draußen? Bevor Du einen Lebenslauf schreibst, der Personaler*innen überzeugt, musst Du Dir ein paar Gedanken über Aufbau und Inhalt machen.',
  },
  '301280.95c672': {
    title: 'Lücken im Lebenslauf erklären: So überzeugst Du im Lebenslauf',
    description:
      'Lerne, wie Du Lücken im Lebenslauf positiv darstellst, häufige Gründe verstehst und erfolgreiche Strategien für den Umgang damit im Bewerbungsgespräch anwendest.',
  },
  '301301.d878c9': {
    title: 'Berufserfahrung im Lebenslauf korrekt angeben – Tipps & Beispiele',
    description:
      'Mit unseren Tipps zur Präsentation von Berufserfahrung optimierst du deinen Lebenslauf. Was darf auf keinen Fall fehlen und was kannst du auch weglassen. Hier erfährst du es.',
  },
  '301341.1dcb13': {
    title: 'Clever mit Elternzeit im Lebenslauf umgehen - so klappt es!',
    description:
      'Hier erfährst Du, wie du die Elternzeit im Lebenslauf optimal präsentierst, um Lücken zu vermeiden und erworbenen Fähigkeiten effektiv hervorzuheben.',
  },
  '301204.48f82b': {
    title: 'Fehler im Lebenslauf: Vermeide unbedingt diese 10 Stolperfallen',
    description:
      'Entdecke die häufigsten Fehler im Lebenslauf und wie Du sie vermeidest, um Deine Chancen auf den Traumjob zu erhöhen. Erfahre, wie Du Deinen Lebenslauf optimierst!',
  },
  '301306.4a7679': {
    title:
      'Der individuelle Lebenslauf, der Arbeitgeber begeistert - So geht es!',
    description:
      'Erhöhe deine Jobchancen mit einem individuellen Lebenslauf: Tipps zur Anpassung, persönlichen Gestaltung und Vermeidung häufiger Fehler. Jetzt lesen!',
  },
  '303714.eeed38': {
    title: "Auslandsaufenthalt im Lebenslauf als Karriere-Booster - So geht's!",
    description:
      'Entdecke, wie Du Deinen Auslandsaufenthalt im Lebenslauf präsentierst und Deine internationale Erfahrung optimal zur Geltung bringst. Erfahre mehr!',
  },
  '303716.c80eb0': {
    title:
      "Kurzbewerbung meistern: Kompakt, prägnant, erfolgreich – so geht's!",
    description:
      'Entdecke den ultimativen Guide zur Kurzbewerbung. Lerne, was sie ist, wie sie aussieht und wann du sie nutzen solltest. Erfolg beginnt hier.',
  },
  '303735.fa991b': {
    title: 'Optimale persönliche Daten im Lebenslauf',
    description:
      'Entdecke, welche persönlichen Angeben Du im Lebenslauf präsentieren solltest. Lerne, welche persönlichen Daten zählen und wie Du sie richtig darstellst.',
  },
  '303737.82a4fb': {
    title: 'Selbstständigkeit im Lebenslauf: So steigern Sie Ihre Jobchancen',
    description:
      'Entdecke, wie du deine Selbstständigkeit im Lebenslauf präsentierst und jeden Arbeitgeber beeindruckst. Lerne, Erfolge hervorzuheben und Fähigkeiten zu betonen.',
  },
  '303746.8d7b37': {
    title: 'Anonyme Bewerbung: Fairer Start im Job - So gelingt der Einstieg!',
    description:
      'Entdecke die Vorteile und Herausforderungen der anonymen Bewerbung. Erfahre, wie sie Chancengleichheit fördert und Diskriminierung im Bewerbungsprozess verhindert.',
  },
  '303761.980b27': {
    title: 'Bewerbungsverfahren: Leitfaden für eine erfolgreiche Bewerbung',
    description:
      'Alles über das Bewerbungsverfahren: Von der Stellenausschreibung bis zur Einstellung. Tipps, Kosten und Phasen im Überblick.',
  },
  '303805.50cc66': {
    title: 'Bewerbung zurückziehen: Klug handeln und neue Wege entdecken',
    description:
      'Bei der Berufswahl kann es vorkommen, dass man sich doch gegen ein Unternehmen entscheidet oder einen zugesagten Job absagen möchte. Hier findest Du die richtigen Tipps.',
  },
  '303828.85aa65': {
    title:
      'Vorstellungsgespräch absagen leicht gemacht - Hier erfährst Du wie!',
    description:
      'Du musst ein Vorstellungsgespräch verschieben oder absagen? Das kann unangenehm sein, muss es aber nicht. Diese Tipps helfen, um freundlich und professionell zu bleiben.',
  },
  '303848.3946b6': {
    title: 'Die beste Schriftart für Deine Bewerbung - Professionell punkten!',
    description:
      'Entdecke die perfekte Schriftart für deine Bewerbung! Unsere Expertentipps helfen dir, einen professionellen Eindruck zu hinterlassen und dich von der Masse abzuheben.',
  },
  '303851.93559f': {
    title:
      'Telefoninterviews leicht gemacht: Hier ist die ultimative Anleitung!',
    description:
      'Verbessere Deine Telefoninterviews: Tipps, Fragen und bewährte Strategien für erfolgreiches Telefonieren. So überzeugst Du spielend!',
  },
  '309901.587c1f': {
    title: 'Erfolgreiche Praktikumsbewerbung: Dein Wegweiser zum Ziel!',
    description:
      'Sichere Dir Deinen Praktikumsplatz mit einem Bewerbungsschreiben, das überzeugt. Hol Dir jetzt die besten Tipps für Deinen Erfolg auf Bewerbung.com!',
  },
  '309890.02dbeb': {
    title: "Mit Top-Bewerbungsschreiben zur Ausbildung: So gelingt's!",
    description:
      'Mach das Rennen um Deinen Ausbildungsplatz mit einem Anschreiben, das überzeugt. Unverwechselbare Tipps für Deinen Erfolg – hol Dir jetzt den Guide!',
  },
  '309850.b85ebc': {
    title: 'Effektiver Aufbau: Eine Bewerbungsmappe, die überzeugt!',
    description:
      'So baust Du eine Bewerbungsmappe auf, die überzeugt: Professionell, strukturiert, erfolgreich. Hol Dir die besten Tipps für eine beeindruckende Bewerbung.',
  },
  '310019.53d3fe': {
    title: 'Perfekter Aufbau für das Anschreiben - Bewerbungstipps',
    description:
      'Hier lernst Du, wie ein überzeugendes Anschreiben aufgebaut wird – mit unserer Experten-Anleitung stehst dir bei deiner nächsten Bewerbung ganz vorn!',
  },
  '310020.8cc585': {
    title: 'Bewerbungsschreiben: Unschlagbare Tipps & Tricks!',
    description:
      'Meistere Dein Bewerbungsschreiben mit unseren Expertentipps. Öffne die Türen zu Deinem Traumjob mit einem Anschreiben, das heraussticht!',
  },
  '310021.9faf65': {
    title: 'Die optimale Reihenfolge Deiner Bewerbung - Auf zum Traumjob!',
    description:
      'Meistere die Reihenfolge Deiner Bewerbung für maximalen Erfolg! Unser Leitfaden bringt Deine Dokumente in die richtige Ordnung und Dir den Job näher.',
  },
  '312670.fa59e9': {
    title: 'Kündigungsschreiben: Der elegante Job-Exit in 5 Schritten',
    description:
      'Erfahre, wie Du Dein Kündigungsschreiben professionell und stilvoll verfasst. Nutze die Tipps für einen reibungslosen Übergang zu Deinem nächsten Karriereschritt!',
  },
  '312777.1daf56': {
    title:
      'Der perfekte Arbeitsvertrag: So startest Du optimal in Deine Karriere',
    description:
      'Erfahre, wie Du mit dem richtigen Arbeitsvertrag Deine Karriere von Anfang an erfolgreich gestaltest und welche wichtigen Punkte Du beachten solltest.',
  },
  '312781.bb4671': {
    title: 'Der Auflösungsvertrag: Alles, was Du wissen musst!',
    description:
      'Erfahre, warum ein Auflösungsvertrag ein eleganter Ausstieg sein kann, welche Vor- und Nachteile er hat, und wie Du Deinen beruflichen Übergang optimal gestalten kannst.',
  },
  '312785.1510cd': {
    title: '5 goldene Regeln für konstruktives Feedback: Das musst du beachten',
    description:
      'Erfahre, wie du mit konkreten Beispielen und einer positiven Haltung wirksames Feedback geben kannst und so zur Weiterentwicklung des Teams beiträgst.',
  },
  '312786.081010': {
    title: 'Headhunter-Tipps: Strategien für beruflichen Erfolg',
    description:
      'Entdecke, wie Headhunter Dein Berufsleben verändern können und erfahre, wann der richtige Zeitpunkt für die Zusammenarbeit ist. Alle Infos hier!',
  },
  '312788.a697e9': {
    title:
      'Erfolgreicher Praktikumsbericht: Tipps für einen überzeugenden Bericht',
    description:
      'Mit einem professionell verfassten Praktikumsbericht präsentierst du deine Einblicke mit Überzeugungskraft. Alle Infos gibt es hier!',
  },
  '312797.38a9a0': {
    title: 'Finde den richtigen Job mit dem perfekten Persönlichkeitstest',
    description:
      'Erfahre, wie Persönlichkeitstests dir helfen, den idealen Job zu finden. Welcher Test ist der passende für dich und wie nutzt du die Ergebnisse am besten für deine Karriere?',
  },
  '312811.14333f': {
    title:
      'Alles über außerordentliche Kündigung: Rechte, Fristen & Handlungsmöglichkeiten',
    description:
      'Erfahre, was eine außerordentliche Kündigung ist, wann sie möglich ist und wie Du richtig handelst. Gratis Muster-Kündigung inklusive!',
  },
  '312823.68de29': {
    title: 'Probezeit erfolgreich gestalten: Alle wichtigen Tipps und Infos!',
    description:
      'Erfahre alles zur gesetzlichen Probezeit, bewährte Tipps und mögliche Gründe für das Scheitern. Erfolgreich in die neue Karriere starten!',
  },
  '315156.b0f8f6': {
    title: 'Anschreiben mit Lücken im Lebenslauf: So überzeugst Du!',
    description:
      'Unsere Tipps zeigen, wie du Lücken im Lebenslauf positiv formulierst und als Stärke im Anschreiben präsentierst. So überzeugst Du!',
  },
  '315160.bb1d97': {
    title: 'Bewerbungsanschreiben: Überzeuge mit deiner Motivation!',
    description:
      'Erfahre, wie du dein Bewerbungsanschreiben mit überzeugender Motivation zum Erfolg machst und dich von der Masse abhebst.',
  },
  '315161.b27feb': {
    title: 'Die häufigsten Fehler im Anschreiben vermeiden',
    description:
      'Erfahre, wie du die häufigsten Fehler im Anschreiben vermeiden kannst und erhöhe deine Chancen auf eine erfolgreiche Bewerbung.',
  },
  '315166.8fdbcd': {
    title: "Anschreiben auf Englisch: Dos and Don'ts für Jobs",
    description:
      "Erfahre die Dos and Don'ts für ein überzeugendes Anschreiben auf Englisch, um sich international zu bewerben. Jetzt informieren und durchstarten!",
  },
  '315167.7da66b': {
    title: 'Anschreiben ohne Berufserfahrung: So überzeugst Du',
    description:
      'Erfahre, wie du ohne Berufserfahrung ein überzeugendes Anschreiben erstellst und erfolgreich in den Beruf einsteigst.',
  },
  '315174.b69794': {
    title: 'Der perfekte Einstiegssatz für dein Anschreiben!',
    description:
      'Entdecke, wie du mit dem perfekten Einstiegssatz im Anschreiben sofort überzeugst. Tipps & Beispiele für einen gelungenen Start.',
  },
};
